import { Base } from "ui/Scripts/source/framework/base";
import { FrontFileItem, IFrontFileItem } from "./frontFileItem";

export interface IFrontFileItems {
    items: IFrontFileItem[];
}

export class FrontFileItems implements IFrontFileItems {
    items: FrontFileItem[];

    constructor();
    constructor(obj: IFrontFileItems);
    constructor(obj?: any) {
        this.items = Base.getTypedArray(obj?.items, FrontFileItem);
    }
}